// external
import styled from 'styled-components';

export const ChangeVehicleHeaderContainerWrapper = styled.div`
    width: 100%;
    container-name: changeVehicleHeaderContainerWrapper;
    container-type: inline-size;
`;

export const ChangeVehicleHeaderContainer = styled.div`
    margin: 0 auto;
    width: 100%;
`;

export const SearchAndSelectVehicleContainerWrapper = styled.div`
    width: 100%;
    container-name: selectVehicleContainerWrapper;
    container-type: inline-size;
    min-height: 350px;

    display: flex;
    gap: ${({ theme }) => theme.tokens.BaseSpace80};
`;

export const SearchAndSelectVehicleContainer = styled.div<{ showFilters?: boolean }>`
    margin: 0 auto;
    width: 100%;

    #ai-assisted-search-container {
        display: flex;
        flex-direction: column;
        gap: 15px;
        #ai-assisted-search-results {
            padding: 15px;
            width: 100%;
            height: 300px;
        }
    }
`;

export const ChangeVehicleTabsContainer = styled.div`
    #change-vehicle-tabs {
        width: 100%;
        margin-bottom: 16px;
    }
`;
